var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('progress',{staticClass:"progress-indicator",class:_vm.progressClass,attrs:{"max":_vm.max},domProps:{"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }